module.exports = __webpack_public_path__ + "static/media/LogoIcon.43aca471.svg";